var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.79 2.644a.879.879 0 00-.645-.283h-.94V.591H2.798v1.77h-.943a.875.875 0 00-.873.944A6.027 6.027 0 003.28 7.56 4.208 4.208 0 006.3 9.748v1.713h1.4V9.748a4.208 4.208 0 003.022-2.19 6.027 6.027 0 002.295-4.253.873.873 0 00-.227-.66zm-10.935.592h.943v2.368c0 .07.002.138.005.207a5.145 5.145 0 01-.948-2.575zm9.343 2.573a4.55 4.55 0 00.005-.205V3.236h.941A5.145 5.145 0 0111.2 5.81zm-6.762 6.413a.875.875 0 00-.875.875v.728c0 .096.078.175.175.175h6.53a.175.175 0 00.175-.175v-.728a.875.875 0 00-.875-.875h-5.13z",
    fill: "#FCBF28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.11 0H2.892a.702.702 0 000 1.403h8.22a.702.702 0 100-1.403zM8.33 11.407H5.672a.815.815 0 00-.815.815h4.286a.815.815 0 00-.815-.815z",
    fill: "#FF934A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.109 4.353L7.983 4.25a.257.257 0 01-.206-.14l-.6-1.195a.257.257 0 00-.465.01L6.19 4.1a.257.257 0 01-.21.151l-1.11.102a.257.257 0 00-.125.464l.856.613a.257.257 0 01.092.297l-.4 1.088a.257.257 0 00.36.316l1.18-.618a.257.257 0 01.235-.002l1.249.63a.257.257 0 00.355-.321l-.416-1.088a.257.257 0 01.094-.303l.882-.61a.257.257 0 00-.123-.466z",
    fill: "#FFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCup);
export default __webpack_public_path__ + "static/media/cup.a489eb75658a4b06cfa2494681679576.svg";
export { ForwardRef as ReactComponent };